var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-1111 -2774)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11291",
    width: 24,
    height: 24,
    transform: "translate(1111 2774)",
    fill: "#92a1b6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_remove",
    d: "M10.807,2a1.944,1.944,0,0,0-1.377.57L9,3H4A1,1,0,1,0,4,5H20a1,1,0,1,0,0-2H15l-.43-.43A1.942,1.942,0,0,0,13.193,2ZM4.365,7,5.893,20.264A2.007,2.007,0,0,0,7.875,22h8.248a2.008,2.008,0,0,0,1.984-1.744L19.635,7Z",
    transform: "translate(1111 2774)",
    fill: "#92a1b6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.dc93259d9236e13f97bad19e9167a8e2.svg";
export { ForwardRef as ReactComponent };